export default {
  meta: {
    title: '踩点任务详情-分享'
  }
};
